







































import { Component, Prop, Vue } from "vue-property-decorator";
import CtaButton from "../ctaButton/ctaButton.vue";
import HomeCarouselFrame from "./HomeCarouselFrame.vue";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

@Component({
  components: { CtaButton, HomeCarouselFrame, VueSlickCarousel },
})
export default class HomeAbout extends Vue {
  @Prop({ type: Array, default: () => [] }) images!: string[];

  get visibleImages() {
    const list = Array.isArray(this.images) ? this.images : [];
    return list.filter((img) => !!img);
  }

  get shouldAutoplay() {
    return this.visibleImages.length > 3;
  }

  get carouselClass() {
    const count = this.visibleImages.length;
    if (count <= 1) return "homeAbout__carousel--single";
    if (count === 2) return "homeAbout__carousel--double";
    return "";
  }

  get carouselSettings() {
    const total = this.visibleImages.length;
    if (total <= 2) {
      return {
        arrows: false,
        dots: false,
        infinite: false,
        slidesToShow: total,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: "0px",
        variableWidth: false,
        autoplay: false,
        speed: 900,
        autoplaySpeed: 5000,
        cssEase: "ease-in-out",
        pauseOnHover: false,
        pauseOnFocus: false,
        draggable: false,
        swipe: false,
        touchMove: false,
      };
    }
    const visibleSlides = total < 3 ? total : 3;
    const shouldLoop = total > visibleSlides;
    return {
      arrows: false,
      dots: false,
      infinite: shouldLoop,
      slidesToShow: visibleSlides,
      slidesToScroll: 1,
      autoplay: this.shouldAutoplay,
      speed: 900,
      autoplaySpeed: 5000,
      cssEase: "ease-in-out",
      pauseOnHover: false,
      pauseOnFocus: false,
    };
  }

  nextSlide() {
    const carousel = this.$refs.carousel as any;
    if (carousel && carousel.next) {
      carousel.next();
    }
    this.restartAutoplay();
  }

  prevSlide() {
    const carousel = this.$refs.carousel as any;
    if (carousel && carousel.prev) {
      carousel.prev();
    }
    this.restartAutoplay();
  }

  restartAutoplay() {
    if (!this.shouldAutoplay) return;
    const carousel = this.$refs.carousel as any;
    if (!carousel) return;
    if (carousel.pause) {
      carousel.pause();
    } else if (carousel.slickPause) {
      carousel.slickPause();
    }
    if (carousel.play) {
      carousel.play();
      return;
    }
    if (carousel.slickPlay) {
      carousel.slickPlay();
    }
  }
}
